const findAll = (selector, el = document) => el.querySelectorAll(selector);

export {findAll};
